import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import { KeyValue } from "../../models/key-value";
import "./Key-Value-Displayer.scss"

interface IProps {
  keyValues: KeyValue[];
}

interface IState {
  keyValues: KeyValue[];
}


export default class KeyValueDisplayer extends React.Component<IProps, IState> {


  state: IState =
    {
      keyValues: null
    }

  constructor(props: IProps) {
    super(props);
  }

  async componentDidMount() {
    this.setState({ keyValues: this.props.keyValues });
  }

  render() {

    return (
      (this.state.keyValues &&
        <table className="table table-bordered key-value-table">
          <tbody>
            {this.state.keyValues.map(keyValue =>
              <tr key={keyValue.key}>
                <td className="pe-3">
                  {keyValue.key}
                </td>
                <td>
                  {keyValue.value}
                </td>
              </tr>
            )
            }
          </tbody>
        </table>
      )
    )
  }
}
